import { motion } from "framer-motion";
import { pageOpen } from "@/lib/animations";


export default function PageTransition({ children, testId }) {
  return (
    <motion.main
      initial={pageOpen.initial}
      animate={pageOpen.animate}
      exit={pageOpen.exit}
      transition={pageOpen.transition}
      className="relative overflow-hidden"
      data-testid={testId}
    >
      {/* Blur decorative background */}
      <div className="pointer-events-none absolute inset-0 opacity-60">
        <div className="absolute -left-20 top-24 h-56 w-56 rounded-full bg-[#f2e6c9]/60 blur-3xl" />
        <div className="absolute right-0 top-[22%] h-64 w-64 rounded-full bg-[#e9d6aa]/45 blur-3xl" />
        <div className="absolute left-[30%] top-[70%] h-52 w-52 rounded-full bg-[#f8efdb]/55 blur-3xl" />
      </div>

      <div className="relative z-10">{children}</div>
    </motion.main>
  );
}